import useViewport from '@/hooks/useBBViewport'
import { WebVideo as AlliumWebVideo } from '@telus-uds/components-web'
import React, { useContext } from 'react'
import { YouTubeEvent } from 'react-youtube'
import { ContentfulAnalyticsEventType } from 'src/siteBuilder/utils/types/analytics'
import useKoodoAnalyticsEvent from '../../../../hooks/useKoodoAnalyticsEvent'
import { SiteBuilderContext } from '../../../renderer/context/SiteBuilderContext'

import { pickDataAttrs } from '@/siteBuilder/utils/dataAttributes'
import { contentfulLoader } from '../Image/contentfulLoader'

import { VIEWPORT_SIZES } from '@/constants/VIEWPORT'
import alloyEvents from '@/siteBuilder/utils/alloyAnalytics/youtubeVideo'
import { isNil } from '@/siteBuilder/utils/isNil'
export type VideoYouTubeProps = {
  videoId: string
  videoLength: number
  aspectRatio?: '16:9' | '4:3' | '1:1'
  beginMuted?: boolean
  defaultVolume?: number
  posterSrc?: string
  linkAnalyticsEvent?: ContentfulAnalyticsEventType
}

/* istanbul ignore next */
const VideoYouTube = ({
  videoId,
  videoLength,
  aspectRatio = '16:9',
  beginMuted = true,
  defaultVolume = 1,
  posterSrc,
  linkAnalyticsEvent,
  ...rest
}: VideoYouTubeProps) => {
  const { locale, isWebpSupported } = useContext(SiteBuilderContext)
  const [isAnalyticsTriggered, setIsAnalyticsTriggered] = React.useState(false)
  const viewport = useViewport()
  const currentVideoState = React.useRef<number>(-1)

  useKoodoAnalyticsEvent(linkAnalyticsEvent, isAnalyticsTriggered)

  if (!isNil(posterSrc) && isNil(viewport)) return null

  const videoOnStartCallback = () => {
    setIsAnalyticsTriggered(true)
  }

  const onPlayEvent = (event?: YouTubeEvent<number>) => {
    if (currentVideoState.current === 2) {
      alloyEvents.resume({ videoId, player: event.target })
    } else {
      alloyEvents.play({ videoId, player: event.target })
    }
    currentVideoState.current = 1
  }

  const onPauseEvent = (event?: YouTubeEvent<number>) => {
    currentVideoState.current = 2
    alloyEvents.pause({ videoId, player: event.target })
  }

  const onCompleteEvent = (event?: YouTubeEvent<number>) => {
    currentVideoState.current = 0
    alloyEvents.complete({ videoId, player: event.target })
  }
  // TODO: remove wrapper div when the new EHC is pushed
  return (
    <div>
      <AlliumWebVideo
        copy={locale.language}
        videoId={videoId}
        videoLength={videoLength}
        aspectRatio={aspectRatio}
        beginMuted={beginMuted}
        defaultVolume={defaultVolume}
        posterSrc={posterSrc && contentfulLoader(isWebpSupported)({ src: posterSrc, width: VIEWPORT_SIZES[viewport] })}
        onStart={videoOnStartCallback}
        onPlay={onPlayEvent}
        onEnd={onCompleteEvent}
        onPause={onPauseEvent}
        {...pickDataAttrs(rest)}
      />
    </div>
  )
}

export default VideoYouTube
